import React, { JSX } from "react";
import { useSelector } from "react-redux";

import { useTranslation } from "react-i18next";
import { Fade } from "@mui/material";

import loadingViewSvg from "../../assets/images/loading.svg";

import { useStyles } from "../data/DataStyles";
import { DashboardSelectors } from "../../redux/selectors/unifiedSelectors";

export const BodyLoadingDashboardModal = (): JSX.Element => {
  const { loadingDashboardInfo, loading, activityChart } =
    useSelector(DashboardSelectors);
    
  const classes = useStyles();
  const [t] = useTranslation("global");

  return (
    <div className="loading-views-div">
      <Fade
        in={
          loadingDashboardInfo ||
          loading.dynamicCharts ||
          loading.slugs ||
          activityChart.loading
        }
        timeout={500}
      >
        <div className={classes.paperModal}>
          <h2 className="title-export">{`${t(
            "Common_options.Loading"
          )}${"..."}`}</h2>
          <img src={loadingViewSvg} alt="loadingViewSvg" />
        </div>
      </Fade>
    </div>
  );
};
